import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import { Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import axios from 'axios';
import * as yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { FormError } from '~/components/form/FormError';
import { PresetAutocomplete } from '../PresetAutocomplete';
const formSchema = yup
    .object({
    medicationName: yup.string().required('Medication name is required'),
    medicationDescription: yup.string().nullable()
})
    .required();
export const AddMedicationModal = (props) => {
    const { onRequestClose, itemToEdit, patientId, onSuccess } = props;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const methods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            medicationName: itemToEdit ? itemToEdit.medicationName : '',
            medicationDescription: itemToEdit ? itemToEdit.medicationDescription : ''
        },
    });
    const { formState: { errors }, handleSubmit, register, } = methods;
    const onFormSubmit = async ({ medicationName, medicationDescription }) => {
        setIsSubmitting(true);
        const data = {
            medicationName: medicationName == '' ? null : medicationName,
            medicationDescription: medicationDescription == '' ? null : medicationDescription
        };
        if (itemToEdit) {
            const response = await axios.post('/api/carePlan/editMedication', {
                medicationId: itemToEdit.id,
                medicationName: data.medicationName,
                medicationDescription: data.medicationDescription
            });
            console.log('response from edit problem');
            console.log(response);
            console.log(response.data);
            console.log(response.data.data);
            console.log(response.data.data.new_medication);
            const new_medication = response.data.data.new_medication;
            const updatedMedication = {
                id: new_medication.id,
                patientId: new_medication.patient_id,
                carePlanId: new_medication.care_plan_id,
                medicationName: new_medication.medication_name,
                medicationDescription: new_medication.medication_description,
                updatedAt: new Date(new_medication.updated_at),
                deletedAt: new Date(new_medication.deleted_at),
                createdAt: new Date(new_medication.created_at),
                isEditable: new_medication.is_editable,
                month: new_medication.month
            };
            onSuccess(updatedMedication);
        }
        else {
            const response = await axios.post('/api/carePlan/addMedication', {
                patientId: patientId,
                medicationName: data.medicationName,
                medicationDescription: data.medicationDescription
            });
            const new_medication = response.data.data.new_medication;
            const updatedMedication = {
                id: new_medication.id,
                patientId: new_medication.patient_id,
                carePlanId: new_medication.care_plan_id,
                medicationName: new_medication.medication_name,
                medicationDescription: new_medication.medication_description,
                updatedAt: new Date(new_medication.updated_at),
                deletedAt: new Date(new_medication.deleted_at),
                createdAt: new Date(new_medication.created_at),
                isEditable: new_medication.is_editable,
                month: new_medication.month
            };
            onSuccess(updatedMedication);
        }
        setIsSubmitting(false);
    };
    return (React.createElement(Dialog, { open: true, PaperProps: {
            sx: { maxHeight: '60vh', maxWidth: '50%', width: '50%' }
        } },
        React.createElement(DialogTitle, { sx: { m: 0, p: 2, display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between' }, id: "customized-dialog-title" },
            itemToEdit ? 'Edit Medication' : 'Add Medication',
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(FormProvider, { ...methods },
                React.createElement("form", { onSubmit: handleSubmit(onFormSubmit), noValidate: true },
                    React.createElement("div", { className: "mb-5", style: { marginLeft: 'auto', marginRight: 'auto', width: '70%' } },
                        React.createElement("div", { className: "flex justify-between items-center" },
                            React.createElement("div", { style: { width: '100%' } },
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Medication"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "medicationName", presets: props.presets, category: "medication", field: "medication", placeholder: "e.g., Tirzepatide 7.5 mg weekly" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Description/Notes"),
                                React.createElement("div", { className: "row" },
                                    React.createElement("textarea", { className: 'problem-list-scroll', onKeyDown: (event) => event.stopPropagation(), style: {
                                            fontFamily: 'Barlow',
                                            verticalAlign: 'top',
                                            overflowY: 'scroll',
                                            height: '85px',
                                            padding: '10px',
                                            width: '100%',
                                            borderWidth: '1px',
                                            borderColor: '#B9B9B9',
                                            borderRadius: '4px'
                                        }, placeholder: 'Enter Notes', ...register('medicationDescription'), defaultValue: itemToEdit?.medicationDescription ?? '' })),
                                React.createElement(FormError, { errors: errors, name: "add-problem" })))),
                    React.createElement("div", { className: "flex justify-between items-center" },
                        React.createElement(Button, { style: { width: '100%' }, variant: "contained", disabled: isSubmitting, type: "submit", color: "primary" }, itemToEdit ? 'Edit Medication' : 'Add Medication')))))));
};
